import { useParams } from "react-router-dom";
import ContentEditor from "@/components/ContentEditor";
import { SITE_SECTIONS } from "@/pages/AdminSiteSettings";

/**
 * Generic route /admin/icerik/:key — dispatches to ContentEditor for the given key.
 * Reads section metadata from SITE_SECTIONS to determine label + capabilities.
 */
export default function AdminContentGeneric() {
  const { key } = useParams();
  const item = SITE_SECTIONS.flatMap((g) => g.items).find((i) => i.key === key);

  return (
    <ContentEditor
      contentKey={key}
      pageHeading={item?.label ? `Düzenle: ${item.label}` : `İçeriği düzenle: ${key}`}
      description={item?.description}
      icon={item?.icon}
      redirectPath="/admin/ayarlar"
      successMessage="Güncellendi"
      showCta={item?.hasCta}
      showImage={item?.hasImage}
    />
  );
}
